import { render, staticRenderFns } from "./SingleFieldWidget.vue?vue&type=template&id=404fbab8&scoped=true"
import script from "./SingleFieldWidget.vue?vue&type=script&lang=js"
export * from "./SingleFieldWidget.vue?vue&type=script&lang=js"
import style0 from "./SingleFieldWidget.vue?vue&type=style&index=0&id=404fbab8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404fbab8",
  null
  
)

export default component.exports